import script from "./NormalMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NormalMessage.vue?vue&type=script&setup=true&lang=ts"

import "./NormalMessage.vue?vue&type=style&index=0&id=4868aeb6&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4868aeb6"]])

export default __exports__